module.exports = __webpack_public_path__ + "assets/restaurant_type-210d9b.svg";